<template>
  <Popup
    title="活动规则"
    :visible.sync="visible"
    :message="[]"
    :showConfirmButton="false"
    v-bind="popAttrs"
  >
    <div class="rule_wrap">{{ ruleText }}</div>
  </Popup>
</template>

<script>
import Popup from '@/components/Popup.vue';
export default {
  components: {
    Popup
  },
  props: {
    ruleText: {
      type: String,
      default: ''
    },
    popAttrs: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      visible: false,
    }
  },
  methods: {
    triggerVisible (v) {
      this.visible = v
    }
  },
}
</script>

<style lang="scss" scoped>
.rule_wrap {
  white-space: pre-wrap;
  text-align: left;
  max-height: 56vh;
  overflow: auto;
  line-height: 1.2;
  padding: 2px 0;
}
</style>